import { styled } from "../../../../styles";

export const Container = styled("div", {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  // Tile has padding: 16px and maxHeight: 628px → content-area max is ~596px.
  // Cap Container at that so ScrollableContent can flex/scroll when the rows
  // overflow, but the modal still shrinks to content (e.g. confirm state).
  maxHeight: "596px",

  variants: {
    // Confirm step shows a short message — drop the height cap and the
    // hidden-overflow so the modal sizes to content and never shows a
    // scrollbar for that step.
    compact: {
      true: {
        maxHeight: "none",
        overflow: "visible",
      },
    },
  },
});

export const ScrollableContent = styled("div", {
  flex: "1 1 auto",
  minHeight: 0,
  overflowY: "auto",
  // No top padding — HeaderRow sits above and supplies it. Keeping the scroll
  // area below the header is also what stops its scrollbar from running under
  // the modal's close button (absolute, 30px tall at top/right 8px).
  padding: "0 46px 8px",

  variants: {
    compact: {
      true: {
        overflowY: "visible",
        // Confirm step has no header row of its own.
        padding: "16px 46px 8px",
      },
    },
  },
});

export const FooterContainer = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "40px",
  padding: "16px 46px 20px",
  borderTop: "1px solid $gray-20",
  flexShrink: 0,
});

export const Row = styled("div", {
  height: "28px",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",

  marginBottom: "16px",

  p: {
    width: "260px",

    color: "$gray-80",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "28px",
  },

  ".ant-checkbox-wrapper": {
    lineHeight: "0px !important",
  },

  ".ant-checkbox .ant-checkbox-inner": {
    width: "18px !important",
    height: "18px !important",
    borderWidth: "2px !important",

    "&::after": {
      borderWidth: "2px !important",
    },
  },

  variants: {
    disabled: {
      true: {
        // EN-5123: `p` too — the RAG rows label with a <p>, not a <label>, so the max-3 limit needs
        // to dim that as well.
        "label, p": {
          opacity: "0.5",
        },
      },
    },
  },
});

// The "Column / Show" header, pinned above the scroll area so it stays visible
// while the rows scroll — and so the scroll track starts below the modal's
// close button instead of underneath it.
export const HeaderRow = styled(Row, {
  flexShrink: 0,
  padding: "0 46px",
  // Vertical spacing as margin, not padding: Row sets a fixed 28px height, and
  // margins sit outside it whatever the box model.
  marginTop: "16px",
  marginBottom: "26px",
});

export const ColumnTitle = styled("p", {
  width: "260px",

  color: "$charcoal !important",
  fontSize: "14px",
  lineHeight: "22px !important",
});

export const SectionDivider = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  margin: "28px 0 20px",

  "&::after": {
    content: "",
    flex: 1,
    height: "1px",
    backgroundColor: "$gray-20",
  },

  span: {
    color: "$gray-80",
    fontSize: "12px",
    fontWeight: 600,
    letterSpacing: "0.5px",
    textTransform: "uppercase",
  },
});
